import React from "react";
import { withRouter } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import CommentList from "./CommentList";
import CommentForm from "./CommentForm";

class CommentView extends React.Component {
    state = ({

    });


    render() {
        return (
            <div>
                <CommentList comments={this.props.comments} />
                <CommentForm fetch={this.props.fetch} comment_on={this.props.comment_on} data={this.props.data} />
            </div>
        );
    }
}

export default withRouter(withTranslation()(CommentView));


// WEBPACK FOOTER //
// ./src/containers/Comments/CommentView.js